// src/DashboardLayout.js
import React from 'react';
import DashboardHeader from './DashboardHeader';

const DashboardLayout = ({ title, headerAction, children }) => {
  return (
    <div>
      <DashboardHeader />
      <br />
      <main role="main" className="container">
        <div className="starter-template">
          <br />
          <br />

          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="m-0">{title}</h2>
            {headerAction && <div className="d-print-none">{headerAction}</div>}
          </div>

          {children}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
